"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbSchoolSubscriptionTierTypesSchema = exports.DbSupportedLicenseStatusSchema = exports.allLicenses = void 0;
const zod_1 = require("zod");
exports.allLicenses = ['free', 'expired', 'pro', 'trial', 'expiring', 'school', 'start'];
/**
 * all possible status codes of a license
 * this should probably be refactored at some point, suggestion would be to
 * - expiring and trial are the same, these should be merged to 1 (trial)
 * - free and expired are the same, free doesn't seem to be used for new accounts, but it still supported. these 2 should probably both be removed
 * - expiring should not be a status. we have an expire date for that. Each license is able to expire
 */
exports.DbSupportedLicenseStatusSchema = zod_1.z.enum(exports.allLicenses);
exports.DbSchoolSubscriptionTierTypesSchema = zod_1.z.enum(['basic', 'complete', 'plus', 'pay-per-use']);
//# sourceMappingURL=shared.licenses.models.js.map